import { ca } from '@cian/analytics';

export function openQuestion(title: string, number: number, category: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'question',
    page: {
      extra: {
        number_question: number,
        question: title,
        category,
      },
    },
  });
}

export function openArticle(articleName: string, articleLink: string, category: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'article',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        article: articleName,
        article_link: articleLink,
        category,
      },
    },
  });
}

export function caPageCategory(category: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'pageCategory',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        category,
      },
    },
  });
}

export function caCatClick(category: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'cat',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        category,
      },
    },
  });
}

export function caPlaceAnAd(category: string, step: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'placeAnAd',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        category,
        button_placement: step,
      },
    },
  });
}

export function caClickLinksQuestions(category: string, questionId: number, question: string, link: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'HowToSellApartmentLanding',
    label: 'articleQuestion',
    page: {
      pageType: 'HowToSellAnApartment',
      extra: {
        category,
        number_question: questionId,
        question,
        link,
      },
    },
  });
}
